import { AllowOneWhiteSpaceRegexp, NoWhiteSpacesOnBeginningRegexp } from '../constant'

export const replaceTextValueWhiteSpaces = (value?: string) =>
  value?.replace(NoWhiteSpacesOnBeginningRegexp, '').replace(AllowOneWhiteSpaceRegexp, ' ') || ''
